import React from 'react';
import { VaDetails } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../utils/content.json';

const WhatTransferredAssets = () => (
  <VaDetails label="What we consider transferred assets">
    <p>Asset transfers could include these types of transactions:</p>
    <ul>
      <li>You gave away money or property</li>
      <li>You sold a home that isn’t your primary residence</li>
      <li>
        You purchased an annuity, such as an insurance policy that pays you
        monthly or annually
      </li>
      <li>You put money or property into a trust</li>
    </ul>
  </VaDetails>
);

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Transferred assets'),
    transferredAssets: yesNoUI({
      title: content['transferred-assets-default-question'],
      updateUiSchema: formData => ({
        'ui:title':
          {
            CUSTODIAN_FILING_FOR_CHILD_UNDER_18:
              content['transferred-assets-custodian-question'],
            SURVIVING_CHILD:
              content['transferred-assets-surviving-child-question'],
          }[formData?.claimantRelationship] ||
          content['transferred-assets-default-question'],
      }),
    }),
    'view:whatTransferredAssets': {
      'ui:description': WhatTransferredAssets,
      'ui:options': {
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['transferredAssets'],
    properties: {
      transferredAssets: yesNoSchema,
      'view:whatTransferredAssets': {
        type: 'object',
        properties: {},
      },
    },
  },
};
